let IsomorphicURL: typeof URL;

if (typeof window !== 'undefined') {
   IsomorphicURL = window.URL;
} else {
   try {
      IsomorphicURL = require('url').URL;
   } catch {
      // This only ever fails in storybook, where we don't need URL
   }
}

export { IsomorphicURL as URL };
